import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-video-upload"
export default class extends Controller {
  static targets = [
    "youtubeSection"
  ]

  connect() {
    console.log("Job video upload controller connected")
  }

  toggleVideoType(event) {
    const videoType = event.target.value
    
    // Youtube Section verstecken/anzeigen
    if (this.hasYoutubeSectionTarget) {
      if (videoType === 'youtube') {
        this.youtubeSectionTarget.classList.remove('hidden')
      } else {
        this.youtubeSectionTarget.classList.add('hidden')
      }
    }
  }
}
